import { useMemo } from 'react';
import { useLocation, navigate } from '@reach/router';
import { v4 as uuidv4 } from 'uuid';
import path from 'path';
import config from '../components/Global/SWLoginModal/SWLoginModalConfig';
import usingOpcoUrl, { getOpcoUrl } from '@/helpers/prefixHelper';
import { useAllowedUris } from '@/hooks';
import { clearUserSession, setIsFromAppDirect, useAppDispatch, useAppSelector } from '@/store';

export const useLogin = () => {
  const location = useLocation();
  const { origin, pathname } = location;
  const { state, scope: defaultScope, response_type } = config;
  const dispatch = useAppDispatch();
  const { isFromAppDirect } = useAppSelector(({ userSession }) => userSession);
  const allowedUrls = useAllowedUris();

  const scope = process.env.GATSBY_APIX_SCOPE || defaultScope;

  const redirectUri = useMemo(
    () => `${origin}${path.join('/', allowedUrls.paths.selectAccountPage)}`,
    [origin, pathname]
  );

  const loginUrl = useMemo(() => {
    return `${process.env.GATSBY_APIX_BASE_URL}/${process.env.GATSBY_AUTHORIZE_URL}?client_id=${
      process.env.GATSBY_APIX_KEY_CLIENT_ID
    }&state=${state}&redirect_uri=${getOpcoUrl(
      redirectUri
    )}&scope=${scope}&response_type=${response_type}&login_hint=OPCO:${process.env.GATSBY_OPCO}&acr_values=${
      process.env.GATSBY_ACR_VALUE_LOGIN
    }&prompt=login`;
  }, [redirectUri]);

  const storeUUIDs = () => {
    const uuid = uuidv4();
    sessionStorage.setItem('nonce', uuid);
    sessionStorage.setItem('state', state);
    return uuid;
  };

  const handleLogin = () => {
    dispatch(clearUserSession());
    isFromAppDirect && dispatch(setIsFromAppDirect(isFromAppDirect));
    const uuid = storeUUIDs();
    navigate(`${loginUrl}&nonce=${uuid}`);
  };

  const handleExternalLink = (url: string) => {
    usingOpcoUrl(url || '#', true);
  };

  return {
    handleLogin,
    handleExternalLink,
    loginUrl,
  };
};
